import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Field extends Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    step: PropTypes.object.isRequired,
    template: PropTypes.any.isRequired,
  };

  render() {
    const {
      step,
      formik,
      form,
      config,
      template: Template, // Capitalized to enable React Component rendering
    } = this.props;

    return <Template config={config} step={step} formik={formik} form={form} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Content.js